module.exports = __webpack_public_path__ + "img/homeSliderGraphic@2x.dc1199b0.png";